import { render, staticRenderFns } from "./orders-filter.vue?vue&type=template&id=7b251b44"
import script from "./orders-filter.vue?vue&type=script&lang=ts"
export * from "./orders-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b251b44')) {
      api.createRecord('7b251b44', component.options)
    } else {
      api.reload('7b251b44', component.options)
    }
    module.hot.accept("./orders-filter.vue?vue&type=template&id=7b251b44", function () {
      api.rerender('7b251b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/orders-filter.vue"
export default component.exports